// JsFromRoutes CacheKey a57cb1e87b4c06563858004e3d6e66d8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  setupIntent: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/saved_payment_methods/setup_intent'),
  setDefault: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/saved_payment_methods/:id/set_default'),
  index: /* #__PURE__ */ definePathHelper('get', '/api/:venue_slug/:payable_type/:payable_id/saved_payment_methods'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/saved_payment_methods'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/:venue_slug/:payable_type/:payable_id/saved_payment_methods/:id'),
}
